var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form-signin",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.login.apply(null, arguments)
          },
        },
      },
      [
        !_vm.forgotPassword
          ? _c("div", { staticClass: "row" }, [
              _vm.isLoginWithEmail
                ? _c(
                    "div",
                    { staticClass: "mp-0" },
                    [
                      _c("input-form", {
                        staticClass: "w-login-cnt-input",
                        attrs: {
                          id: "inputEmail",
                          lbl: "misc.email",
                          lbl_error: _vm.validationErrors.loginEmail,
                          placeholder: "you@example.com",
                          title: "Insert email address",
                          autofocus: true,
                        },
                        model: {
                          value: _vm.loginEmail,
                          callback: function ($$v) {
                            _vm.loginEmail = $$v
                          },
                          expression: "loginEmail",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mp-0 w-input-pwd" },
                [
                  _c("input-form", {
                    staticClass: "w-login-cnt-input",
                    attrs: {
                      id: "inputPassword",
                      type: !_vm.showPassword ? "password" : "text",
                      lbl: "login.password",
                      lbl_error: _vm.validationErrors.password,
                      placeholder: "Insert here",
                    },
                    model: {
                      value: _vm.input.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.input, "password", $$v)
                      },
                      expression: "input.password",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "w-show-password",
                      attrs: { title: "Show / hide password" },
                      on: {
                        click: function ($event) {
                          _vm.showPassword = !_vm.showPassword
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas",
                        class: {
                          "fa-eye": !_vm.showPassword,
                          "fa-eye-slash": _vm.showPassword,
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {}, [
                _c(
                  "a",
                  {
                    staticClass: "link",
                    on: {
                      click: function ($event) {
                        _vm.forgotPassword = !_vm.forgotPassword
                        _vm.clear()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("login.forgot_password")))]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-block btn-iot btn-login",
                  attrs: { disabled: _vm.disableLogin, type: "submit" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.login()
                    },
                  },
                },
                [
                  _vm._v("\n        Login\n        "),
                  _c("i", {
                    staticClass: "fas fa-spinner fa-spin spin-off",
                    class: { active: _vm.spinOff },
                  }),
                ]
              ),
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _c("input-form", {
                  staticClass: "w-login-cnt-input",
                  attrs: {
                    id: "inputResetEmail",
                    lbl: "misc.email",
                    lbl_error: _vm.validationErrors.resetPasswordEmail,
                    placeholder: "Insert email",
                  },
                  model: {
                    value: _vm.input.resetPasswordEmail,
                    callback: function ($$v) {
                      _vm.$set(_vm.input, "resetPasswordEmail", $$v)
                    },
                    expression: "input.resetPasswordEmail",
                  },
                }),
                _vm._v(" "),
                _c("p", { staticClass: "w-lbl" }, [
                  _vm._v(_vm._s(_vm.$t("login.send_email_password"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-block btn-iot btn-login",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.forgotPassword = !_vm.forgotPassword
                          _vm.clear()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("misc.cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-block btn-iot btn-login",
                      attrs: {
                        disabled: !_vm.input.resetPasswordEmail,
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.resetPassword()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("misc.send")) +
                          "\n          "
                      ),
                      _c("i", {
                        staticClass: "fas fa-spinner fa-spin spin-off",
                        class: { active: _vm.spinOff },
                      }),
                    ]
                  ),
                ]),
              ],
              1
            ),
        _vm._v(" "),
        !_vm.isLoginWithEmail
          ? _c(
              "div",
              {
                staticClass: "row text-center",
                attrs: { id: "new-login-notification" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("login.new_login_notification")) +
                    ":\n      "
                ),
                _c("a", { attrs: { href: "/login" } }, [
                  _vm._v(_vm._s(_vm.loginUrl)),
                ]),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-logo-cnt", attrs: { title: "Login" } }, [
      _c("img", {
        staticClass: "w-logo",
        attrs: {
          rel: "preload",
          alt: "Scm Group",
          src: require("[envbyven]/assets/images/logo.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "oval" }, [
      _c("img", {
        attrs: {
          rel: "preload",
          src: require("@/assets/images/user.png"),
          alt: "User",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }